import { useState } from 'react';
import Head from './toDo component/Head';
import DataAdder from './toDo component/DataAdder';
import ShowData from './toDo component/ShowData';
import './App.css'

const App = () => {

  const [data, setData] = useState("");
  const [addData, setAddData] = useState([]);
  const [holderText, setHolderText] = useState("Add Items");

  const InputData = (e) => {
    setData(e.target.value);
  }

  const addItem = () => {
    if (data !== "") {
      setAddData((oldItem) => {
        return [...oldItem, data];
      });
      setData("");
      setHolderText("Add Items");
    } else {
      setHolderText("Can't Empty");
      console.log(holderText);
    }
  }

  const deleteItem = (id) => {
    setAddData((oldItems) => {
      return oldItems.filter((arrElem, index) => {
        return index !== id;
      });
    });
  }

  return (
    <>
      <div className="container">
        <div className="center_container">
          <Head />
          <div className="body">
            <DataAdder change={InputData} info={data} click={addItem} placeholderText={holderText} />
            <ol className="lists">
              {
                addData.map((itemVal, index) => {
                  return <ShowData key={index} id={index} list={itemVal} onSelect={deleteItem} />
                })
              }
            </ol>
          </div>
        </div>
      </div>
    </>
  );
}

export default App;